<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body style="background:#fff;padding:17px;">
      <div class="item-box">
        <div style="font-size:13px; color:#222;padding:0 0 10px 0;">普通投资者:</div>
        <div class="item-box-title">
          普通投资者特定对象确认需要做风险承受能力测评，个人中心也可以重新测评。 <br/>
          投资者阅读风险提示，点击“开始测评”可以开始风险测评，预计2-3分钟完成私
          募基金管理人的测评模板，提交后可查看风险承受能力等级，等级有:
          <span>C1(风险承受能力最低)、C1、C2、C3、C4、C5</span>
        </div>
        <div class="item-box-slide">
          <cube-slide
            :initialIndex="slideNorIndex"
            :showDots="false"
            :autoPlay="false"
            @change="slideNorChange">
            <cube-slide-item>
              <img src="~@/assets/risk_nor1.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/risk_nor2.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div @click="$_jumpSlideItemNor(slideNorIndex)" style="color:#222;" >
              <i class="cubeic-back"></i>
            </div>
            <div class="item-box-slide-desc-n">
              <span>{{`0${slideNorIndex + 1}`}}</span>/02
            </div>
            <div class="item-box-slide-desc-text">{{['开始测评', '提交问卷'][slideNorIndex]}}</div>
            <div @click="$_jumpSlideItemNor(slideNorIndex)" style="color:#222;">
              <i class="cubeic-arrow"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="item-box">
        <div style="font-size:13px; color:#222;padding:0 0 10px 0;">机构投资者:</div>
        <div class="item-box-title">
          个人中心也可以进行风险承受能力测评投资者阅读风险提示，
          点击“开始测评”可以开始风险测评，预计2-3分钟完成私募基金
          管理人的测评模板，提交后可查看风险承受能力等级，等级有:
          <span>C1(风险承受能力最低)、C1、C2、C3、C4、C5</span>
        </div>
        <div class="item-box-slide">
          <cube-slide
            :initialIndex="slideIndex"
            :showDots="false"
            :autoPlay="false"
            @change="slideChange">
            <cube-slide-item>
              <img src="~@/assets/risk_sp1.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/risk_sp2.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/risk_sp3.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div @click="$_jumpSlideItem(slideIndex)" style="color:#222;" >
              <i class="cubeic-back"></i>
            </div>
            <div class="item-box-slide-desc-n">
              <span>{{`0${slideIndex + 1}`}}</span>/03
            </div>
            <div class="item-box-slide-desc-text">
              {{['个人中心前往测评', '开始测评', '提交问卷'][slideIndex]}}
            </div>
            <div @click="$_jumpSlideItem(slideIndex)" style="color:#222;">
              <i class="cubeic-arrow"></i>
            </div>
          </div>
        </div>
      </div>

    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slideNorIndex: 0,
      slideIndex: 0,
    };
  },
  methods: {
    slideChange(index) {
      this.slideIndex = index;
    },
    slideNorChange(index) {
      this.slideNorIndex = index;
    },
    $_jumpSlideItem(index) {
      if (index < 2) {
        this.slideIndex = index + 1;
      } else {
        this.slideIndex = 0;
      }
    },
    $_jumpSlideItemNor(index) {
      this.slideNorIndex = index === 0 ? 1 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-box {
  margin-bottom: 30px;
  .item-box-title {
    font-size: 13px;
    color: #666666;
    line-height: 18px;
    span {
      color: #ff9800;
    }
  }
  .item-box-slide {
    margin: 10px 0;
    border: 1px solid #eee;
    .item-box-slide-desc {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding: 10px 0;
      color: #999;
      .item-box-slide-desc-n > span {
        color: #2e6be6;
      }
      .item-box-slide-desc-text {
        flex: 0.6;
        font-size: 15px;
      }
    }
  }
}
</style>
